import {
  ProjectLOADING,
  ProjectERROR,
  ProjectListSUCCESS,
  ProjectCreateSUCCESS,
  ProjectUpdateSUCCESS,
  ProjectDeleteSUCCESS,
  ProjectFavoriteListSUCCESS,
  ProjectFavoriteAddSUCCESS,
  ProjectFavoriteRemoveSUCCESS,
} from "./Project.types";

const initialstate = {
  projects: [],
  // Ids of the projects the logged-in user starred in the current
  // organization, pinned to the top of the tracker's project picker.
  favoriteIds: [],
  isLoading: false,
  isError: false,
};

export const ProjectReducer = (state = initialstate, { type, payload }) => {
  switch (type) {
    case ProjectLOADING: {
      return { ...state, isLoading: true };
    }
    case ProjectERROR: {
      return { ...state, isLoading: false, isError: true };
    }
    case ProjectListSUCCESS: {
      return { ...state, projects: Array.isArray(payload) ? payload : [], isLoading: false };
    }
    case ProjectCreateSUCCESS: {
      return { ...state, projects: [...state.projects, payload], isLoading: false };
    }
    case ProjectUpdateSUCCESS: {
      const projects = state.projects.map((p) => (p.id === payload.id ? payload : p));
      return { ...state, projects, isLoading: false };
    }
    case ProjectDeleteSUCCESS: {
      const projects = state.projects.filter((p) => p.id !== payload);
      return { ...state, projects, favoriteIds: state.favoriteIds.filter((id) => id !== payload), isLoading: false };
    }
    case ProjectFavoriteListSUCCESS: {
      return { ...state, favoriteIds: Array.isArray(payload) ? payload : [] };
    }
    case ProjectFavoriteAddSUCCESS: {
      if (state.favoriteIds.includes(payload)) return state;
      return { ...state, favoriteIds: [...state.favoriteIds, payload] };
    }
    case ProjectFavoriteRemoveSUCCESS: {
      return { ...state, favoriteIds: state.favoriteIds.filter((id) => id !== payload) };
    }
    default: {
      return state;
    }
  }
};
